
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/join",
      function () {
        return require("private-next-pages/auth/join/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/join"])
      });
    }
  